<template>
  <div class="blue-grey lighten-4">
    <!-- EDIT DIALOG -->
    <v-dialog v-model="editDialog" persistent max-width="800px" transition="dialog-transition">
      <v-flex class="xs12 ml-0 pl-4 pr-4 pt-4 pb-3 layout row wrap elevation-0 white">

        <v-flex class="xs12">
          <v-text-field v-model="editedInsuranceLog.christies_2022_LOWER_MARKET_value" name="christies_2022_LOWER_MARKET_value" label="Market Value"></v-text-field>
        </v-flex>

        <!-- Reason -->
        <v-flex class="sm12 md6 pr-3">
          <v-text-field v-model="editedInsuranceLog.insurance_value_currency" name="insurance_value_currency" label="Currency"></v-text-field>
        </v-flex>

        <!-- Valuer -->
        <v-flex class="sm12 md6">
          <v-text-field v-model="editedInsuranceLog.insurance_valuer" name="insurance_valuer" label="Valuer"></v-text-field>
        </v-flex>

        <!-- Note -->
        <v-flex class="xs12">
          <v-text-field v-model="editedInsuranceLog.insurance_value_note" name="insurance_value_note" label="Note"></v-text-field>
        </v-flex>

        <!-- IN OUT -->
        <v-flex class="xs6 mb-0 pl-3 mt-1 pt-3">
          <!-- <v-btn-toggle v-model="toggle" @change="saveField(toggle)">
                    <v-btn small flat v-for="s in f_field.selection" :key="s.id ? s.value : s" class="px-2" :value="s.value">
                      <span> {{s.name}} </span>
                    </v-btn>
                  </v-btn-toggle>             -->
          <v-btn-toggle :disabled="c_user.id != 67 && c_user.id != 1" mandatory v-model="editedInsuranceLog.storage"
            active-class="activeToggle">
            <v-btn value="in" small flat class="px-3">
              <v-icon small>call_received</v-icon> IN
            </v-btn>
            <v-btn value="out" small flat class="px-3">
              OUT <v-icon small>call_made</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>

        <!-- DATE -->
        <v-flex xs6 d-flex>
          <!-- :return-value.sync="editedInsuranceLog.insurance_value_date" -->
          <v-flex xs12 md6>
            <v-menu v-model="menu2a" :disabled="c_user.id != 67 && c_user.id != 1" ref="menu2a"
              :close-on-content-click="true" :nudge-right="40" lazy landscape transition="scale-transition" offset-y
              full-width min-width="290px">
              <v-text-field v-model="editedInsuranceLog.insurance_value_date" slot="activator" label="Date" prepend-icon="event"
                readonly></v-text-field>
              <v-date-picker persistent color="black" v-model="editedInsuranceLog.insurance_value_date"></v-date-picker>
              <!-- </v-flex> -->
              <!-- @input="save(editedInsuranceLog.insurance_value_date)" -->
              <!-- @input="$refs.menu2.save(editedInsuranceLog.insurance_value_date)" -->
            </v-menu>
          </v-flex>
          <v-flex xs12 md6>
            <v-menu ref="menu" v-model="menu_time" :close-on-content-click="false" :nudge-right="40"
              :return-value.sync="editedInsuranceLog.change_time" lazy transition="scale-transition" offset-y full-width
              max-width="290px" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="editedInsuranceLog.change_time" label="Picker time if needed"
                  prepend-inner-icon="access_time" readonly v-on="on"></v-text-field>
              </template>
              <v-time-picker v-if="menu_time" v-model="editedInsuranceLog.change_time" full-width format="24hr"
                @click:minute="$refs.menu.save(editedInsuranceLog.change_time)"></v-time-picker>
            </v-menu>
          </v-flex>
        </v-flex>

        <!-- COPY -->
        <v-flex xs12 mt-3 mb-0>{{ editedInsuranceLog.copy }}
          <!-- <v-btn-toggle
                      mandatory
                      v-model="editedInsuranceLog.copy"
                      active-class="activeToggle"
                    >
                      <v-btn small flat class="px-3" value="artwork">Artwork </v-btn>
                      <v-btn
                        small
                        flat
                        class="px-3"
                        value="packings"
                        :disabled="!artwork.artwork_packings"
                        >Parts
                      </v-btn>
                      <v-btn small flat class="px-3" value="master_physical"
                        >Master Physical
                      </v-btn>
                      <v-btn small flat class="px-3" value="archive_master"
                        >Archive Master
                      </v-btn>
                      <v-btn small flat class="px-3" value="access_copy"
                        >Access Copy
                      </v-btn>
                    </v-btn-toggle> -->
          <!-- <v-icon>call_received</v-icon> -->
          <!-- <v-icon>call_made</v-icon>  -->
          <!-- <v-radio-group v-model="artwork_insurance_log.storage" row color="black">
                      <v-radio class="mr-4" name="storage" color="black" value="in" label="Storage In"></v-radio>
                      <v-radio class="mr-4" name="storage" color="black" value="out" label="Storage Out"></v-radio>
                    </v-radio-group> -->
        </v-flex>
        <!-- <v-flex class="xs12 mt-0 pt-0">
                    <v-radio-group v-model="artwork_insurance_log.copy" row>
                      <v-radio name="copy" class="mr-4" color="black" value="artwork" label="Artwork"></v-radio>
                      <v-radio name="copy" class="mr-4" color="black" value="master_physical" label="Master Physical"></v-radio>
                      <v-radio name="copy" class="mr-4" color="black" value="archive_master" label="Archive Master"></v-radio>
                      <v-radio name="copy" class="mr-4" color="black" value="access_copy" label="Access Copy"></v-radio>
                    </v-radio-group>
                  </v-flex> -->

        <!-- :headers="headers" -->
        <!-- <v-data-table
                    v-if="editedInsuranceLog.copy == 'packings'"
                    :items="artwork.artwork_packings"
                    item-key="id"
                    hide-actions
                    hide-headers
                    class="elevation-0 mx-0 mt-0"
                    style="width: 100%;"
                    v-model="selectedPackings"
                  >
                    <template slot="items" slot-scope="props">
                      <td class="py-2 text-xs-right" style="background-color: #f5f5f5;">
                        <v-checkbox
                          color="black"
                          hide-details
                          v-model="props.selected"
                        ></v-checkbox>
                      </td>
                      <td
                        class="py-2 text-xs-right px-4"
                        style="background-color: #f5f5f5;"
                      >
                        {{ props.item.colli }}
                      </td>
                      <td
                        class="py-2 text-xs-right px-4"
                        style="background-color: #f5f5f5;"
                      >
                        {{ props.item.packing }}
                      </td>
                      <td
                        class="py-1 text-xs-right px-4"
                        style="background-color: #f5f5f5;"
                      >
                        {{ props.item.height }} x {{ props.item.width }} x
                        {{ props.item.lenght }} cm - {{ props.item.weight }} kg
                      </td>
                      <td
                        class="py-2 text-xs-right px-4"
                        style="background-color: #f5f5f5;"
                      >
                        {{ get_insurance_name(props.item) }}
                      </td>
                      <td
                        class="py-2 text-xs-right px-4"
                        style="background-color: #f5f5f5;"
                      >
                        {{ props.item.contents }}
                      </td>
                      <td
                        class="py-2 text-xs-right px-4"
                        style="background-color: #f5f5f5;"
                      >
                        {{ get_visa_status(props.item) }}
                      </td>
                    </template>
                    <template slot="no-data">
                      <center>No Packings for this artwork.</center>
                    </template>
                  </v-data-table> -->

        <v-flex class="xs12"></v-flex>

        <v-flex class="xs12 pr-0 mr-0 mt-3" text-xs-right>
          <v-btn small :dark="!(
              editedInsuranceLog.christies_2022_LOWER_MARKET_value == null ||
              editedInsuranceLog.christies_2022_LOWER_MARKET_value == ''
            ) &&
            !(
              editedInsuranceLog.insurance_value_date == null ||
              editedInsuranceLog.insurance_value_date == ''
            )
            " @click="save_edited_artwork_insurance_log" :disabled="editedInsuranceLog.christies_2022_LOWER_MARKET_value == null ||
                editedInsuranceLog.christies_2022_LOWER_MARKET_value == '' ||
                editedInsuranceLog.insurance_value_date == null ||
                editedInsuranceLog.insurance_value_date == ''
          ">save</v-btn>
          <v-btn small @click="editDialog = !editDialog">cancel</v-btn>
          <!-- !(
                        editedInsuranceLog.copy == 'packings' &&
                        selectedPackings.length < 1
                      ) && -->
          <!-- (editedInsuranceLog.copy == 'packings' ) || -->
          <!-- && selectedPackings.length < 1 -->
        </v-flex>
      </v-flex>
    </v-dialog>

    <v-layout column class="mt-0">
      <!-- <h3 class="subheading ml-3 mb-2">Current insurance</h3> -->

      <!-- INSURANCE INFO -->
      <v-flex ml-3 mt-1>
        <!-- <v-flex xs12 v-if="artwork.christies_2022_LOWER_MARKET_value"><v-icon>edit_insurance</v-icon> Artwork: {{lastInsuranceLogArtwork}} </v-flex> -->

        <!-- LATEST ARTWORK INSURANCE -->
        <v-flex xs12 v-if="artwork.christies_2022_LOWER_MARKET_value">
          <!-- <v-icon small>edit_insurance</v-icon> -->
          <b>Latest Artwork Market Valuation</b>
          <!-- <v-icon color="black" small class="ml-2">verified</v-icon> -->
          <!-- <b>{{
            get_insurance_name(artwork.christies_2022_LOWER_MARKET_value)
          }}</b> -->

          <!-- <b class="red--text" v-if="lastInsuranceLogArtwork.christies_2022_LOWER_MARKET_value != artwork.christies_2022_LOWER_MARKET_value">
            <br />Current Insurance of Artwork is different from latest Insurance History entry.<br>
          </b> -->
        </v-flex>

        <!-- LATEST ARTWORK INSURANCE -->
        <v-flex xs12 pt-2 v-if="lastInsuranceLogArtwork">
          <div>
            <!-- <b>Latest Artwork Insurance Valuation: </b> -->
            <v-icon color="black" small class="ml-0 mt-1">verified</v-icon>
            <b>{{ formatMoney(lastInsuranceLogArtwork.christies_2022_LOWER_MARKET_value) }} {{ lastInsuranceLogArtwork.insurance_value_currency }}</b> on 
            <b>{{ lastInsuranceLogArtwork.insurance_value_date }} </b>
            by <b>{{ lastInsuranceLogArtwork.insurance_valuer }} </b><br />
            <span v-if="lastInsuranceLogArtwork.insurance_value_note">({{ lastInsuranceLogArtwork.insurance_value_note }} )<br /></span>
            <span v-if="lastInsuranceLogArtwork.reason">({{ lastInsuranceLogArtwork.reason }} )</span>
            <!-- <span v-if="lastInsuranceLogArtwork.storage" class="mr-3 pl-0">
              <v-icon color="black" small class="ml-3">{{
                lastInsuranceLogArtwork.storage == 'in'
                ? 'call_received'
                : 'call_made'
              }}</v-icon>
              <b>Storage {{ lastInsuranceLogArtwork.storage.toUpperCase() }}</b>
            </span> -->
            <!-- <span v-if="lastInsuranceLogArtwork.reason || lastInsuranceLogArtwork.insurance_value_note">
              ({{ lastInsuranceLogArtwork.reason }}
              <span v-if="lastInsuranceLogArtwork.insurance_value_note != lastInsuranceLogArtwork.reason">{{
                lastInsuranceLogArtwork.insurance_value_note
              }}</span>)
            </span> -->
          </div>
        </v-flex>

        <v-flex v-else xs12 pt-2>
          <v-icon color="black" small class="ml-0">verified</v-icon>
          <b>{{ formatMoney(artwork.christies_2022_LOWER_MARKET_value) }} {{ artwork.insurance_value_currency }}</b>
          <b>({{ artwork.insurance_value_date_year }}-{{ artwork.insurance_value_date_month }}-{{ artwork.insurance_value_date_day }}) </b>
        </v-flex>
      </v-flex>

      <v-layout xs12 sm12 md12 mt-2 ml-0 mr-0 px-0>

        <v-flex xs12>
          <v-flex xs12 row layout>
            <!-- ADD NEW LOG / Change current Insurance -->
            <v-btn class="mt-2 mb-0 ml-3 mr-0" round flat v-if="c_user.edit" @click="switch_change_dialog" small>
              <!-- <v-icon small class="mr-1">near_me</v-icon> -->
              {{
                showUpload ? 'Cancel ' : 'Add Market Valuation'
              }}</v-btn>
            <v-spacer class="pb-0 mb-0"></v-spacer>

            <!-- SHOW INSURANCE HISTORY BUTTON -->
            <v-btn small round flat class="pl-3 pr-2 mx-3" @click="showList = !showList">
              {{ showList ? 'Hide' : 'Show' }} History
              <v-icon v-if="!showList" class="pl-3">expand_more</v-icon>
              <v-icon v-if="showList" class="pl-3">expand_less</v-icon>
            </v-btn>
          </v-flex>

          <!-- CHANGE INSURANCE FORM -->
          <v-card v-if="showUpload" class="
                              xs12
                              ml-0
                              mr-0
                              mt-2
                              mb-2
                              elevation-0
                              ">
            <!-- pl-4
                      wrap
                      round
                      row
                      pr-4
                      pt-4
                      layout
                      pb-3
                      white -->
            <v-card-title class="blue-grey lighten-3 white--text xs12 py-2">
              <h3>Add Market Valuation</h3>
            </v-card-title>

            <v-card-text class="pl-4
                              pr-4
                              pt-3
                              pb-3 wrap row layout">
              <!-- <v-flex class="xs12"> -->

                <v-flex class="sm8 xs12 pr-3">
                  <v-text-field v-model="artwork_insurance_log.christies_2022_LOWER_MARKET_value" name="christies_2022_LOWER_MARKET_value" label="Market Value"></v-text-field>
                </v-flex>

                <!-- Reason -->
                <v-flex class="sm4 xs12">
                  <v-select
                    v-model="artwork_insurance_log.insurance_value_currency"
                    name="insurance_value_currency" :items="constants.CURRENCIES" label="Currency"  
                    hint="Currency">
                  </v-select>

                  <!-- <v-text-field v-model="editedInsuranceLog.insurance_value_currency" name="insurance_value_currency" label="Currency"></v-text-field> -->
                </v-flex>

              <!-- </v-flex> -->

              <v-flex class="sm12 ">
                <v-text-field v-model="artwork_insurance_log.reason" name="reason" label="Reason"
                  class="mr-0"></v-text-field>
              </v-flex>
              
              <v-flex class="sm12 md6">
                <v-text-field  v-model="artwork_insurance_log.insurance_valuer" name="insurance_valuer" label="Valuer" class="mr-3"></v-text-field>
              </v-flex>
              <v-flex xs12 md6 mb-0 pb-0>
                <v-menu v-model="menu2" :disabled="!c_user.edit" :return-value.sync="artwork_insurance_log.insurance_value_date"
                  ref="menu2" :close-on-content-click="true" :nudge-right="40" lazy landscape
                  transition="scale-transition" offset-y full-width min-width="290px">
                  <v-text-field v-model="artwork_insurance_log.insurance_value_date" slot="activator" label="Market Value Date"
                    prepend-inner-icon="event"
                     readonly persistent-hint
                        ></v-text-field>
                    <!-- :hint="artwork_insurance_log.insurance_value_date != '' && artwork_insurance_log.insurance_value_date <=
                        lastInsuranceLogArtwork.insurance_value_date ? 'Date is before or the same as the last change, artwork insurance will not be updated.' : ''" -->
                  <v-date-picker color="black" persistent v-model="artwork_insurance_log.insurance_value_date"
                    @input="$refs.menu2.save(artwork_insurance_log.insurance_value_date)"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex class="xs12">
                <v-text-field v-model="artwork_insurance_log.insurance_value_note" name="insurance_value_note" label="Note"></v-text-field>
              </v-flex>

              <v-flex class="xs12"></v-flex>
              <v-flex class="xs12 pr-0 mr-0 mt-3" text-xs-right>
                <v-btn @click="switch_change_dialog" small flat>cancel</v-btn>
                <v-btn small :dark="!(
                    artwork_insurance_log.christies_2022_LOWER_MARKET_value == null ||
                    artwork_insurance_log.christies_2022_LOWER_MARKET_value == '' ||
                    artwork_insurance_log.insurance_value_currency == null ||
                    artwork_insurance_log.insurance_value_currency == ''
                  ) &&
                  !(
                    artwork_insurance_log.christies_2022_LOWER_MARKET_value == null ||
                    artwork_insurance_log.christies_2022_LOWER_MARKET_value == ''
                  )
                  " @click="showSaveDialog" :disabled="artwork_insurance_log.christies_2022_LOWER_MARKET_value == null ||
                      artwork_insurance_log.christies_2022_LOWER_MARKET_value == '' ||
                      artwork_insurance_log.christies_2022_LOWER_MARKET_value == null ||
                      artwork_insurance_log.christies_2022_LOWER_MARKET_value == ''
                      ">save</v-btn>
              </v-flex>
            </v-card-text>
          </v-card>

          <!-- REVIEW CHANGES -->
          <v-dialog v-model="saveDialog" scrollable persistent :overlay="true" max-width="500px"
            transition="dialog-transition">
            <v-card>
              <v-card-title primary-title class="red white--text pb-2 pt-2">
                <h2>Review Changes</h2>
              </v-card-title>
              <v-card-text>
                <h3 class="mb-3"> New Market Value History entry will be created for:<br> <span class="text-uppercase">{{
                  artwork.title
                }}</span></h3>
                <div>
                  Market Value Date: <b>{{ artwork_insurance_log.insurance_value_date }}</b>
                </div>
                <div>
                  Market Value: <b>{{ artwork_insurance_log.christies_2022_LOWER_MARKET_value }} {{ artwork_insurance_log.insurance_value_currency }}</b>
                </div>
                <div>
                  Market Valuer: <b>{{ artwork_insurance_log.insurance_valuer }} </b>
                </div>
                <div>
                  Reason: <b>{{ artwork_insurance_log.reason }}</b>
                </div>
                <div>
                  Note: <b>{{ artwork_insurance_log.insurance_value_note }}</b>
                </div>
                <!-- <h3 v-if="artwork_insurance_log.insurance_value_date > lastInsuranceLogArtwork.insurance_value_date"> Artwork's Current
                  Insurance will also be changed.</h3>
                <h3 v-else class="red--text"> Artwork's Current Insurance will <b>NOT</b> be changed, because a insurance
                  history entry with
                  newer Change Date exists.</h3> -->
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="cancel" small @click="saveDialog = false">cancel</v-btn>

                <!-- ="!(
                    artwork_insurance_log.christies_2022_LOWER_MARKET_value == null ||
                    artwork_insurance_log.christies_2022_LOWER_MARKET_value == ''
                  ) &&
                  !(
                    artwork_insurance_log.insurance_value_date == null ||
                    artwork_insurance_log.insurance_value_date == ''
                  ) &&
                  !(
                    artwork_insurance_log.insurance_value_currency == null ||
                    artwork_insurance_log.insurance_value_currency == ''
                  )
                  "  -->
                <v-btn small dark
                  @click="save_artwork_insurance_log" :disabled="artwork_insurance_log.christies_2022_LOWER_MARKET_value == null ||
                      artwork_insurance_log.christies_2022_LOWER_MARKET_value == '' ||
                      artwork_insurance_log.insurance_value_currency == '' ||
                      artwork_insurance_log.insurance_value_date == null ||
                      artwork_insurance_log.insurance_value_date == ''
                      ">save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-spacer></v-spacer>

          <!-- INSURANCE HISTORY  -->
          <!-- <v-flex mt-0 d-flex text-xs-right v-if="(artwork.artwork_insurance_logs &&
              artwork.artwork_insurance_logs.length > 0) ||
            (artwork.insurance_history && !showUpload)
            ">
            <v-spacer></v-spacer> -->

            <!-- INSURANCE HISTORY FILTER -->
            <!-- <span v-if="showList" class="mt-0 mr-0">
              <v-menu offset-y :close-on-content-click="true" class="text-xs-right mx-0">

                <template v-slot:activator="{ on }">
                  <v-btn small round flat v-on="on" class="text-xs-right mx-0 mt-0 my-0 py-0 px-3">
                    <span class="text-uppercase mr-3">{{ selectedFilter }}</span>
                    <v-icon small>filter_list</v-icon>
                  </v-btn>
                </template>

                <v-list value="artwork">
                  <v-list-tile v-for="(item, index) in [
                    'INSURANCE',
                    'MARKET',
                  ]" :key="index.id" @click="toggleCopyFilter(item)">
                    <v-list-tile-title>{{ item }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>

              </v-menu>
            </span>

          </v-flex> -->
        </v-flex>
      </v-layout>

      <!-- LIST OF LOGS -->
      <!-- c_user.edit && -->
      <v-flex row xs12 sm12 md12 mt-0 ml-0 mr-0 v-if="showList && (filtered_artwork_insurance_logs &&
            filtered_artwork_insurance_logs.length > 0)">
        <v-list class="xs12 py-0 grey lighten-4" three-line >
          <v-flex my-0 pb-0 pt-2>
            <template v-for="l in filtered_artwork_insurance_logs">
              <!-- <v-divider :key="`divider_${l.id}`"></v-divider> -->
              <v-flex :key="l.id">
                <v-flex px-3 py-0>
                  <v-list-tile-title class="subheading font-weight-bold">
                    <span>{{ l.insurance_value_date }}</span> by <b>{{ l.insurance_valuer }} </b>
                    <small class="right font-weight-thin">
                      <span v-if="l.created_by != null">{{ get_abb(l.created_by) }} -</span>
                      <span v-if="l.created_at != null || l.created_at != ''">{{
                        format_date(l.created_at)
                      }}</span>
                    </small>
                  </v-list-tile-title>

                  <!-- class="body-2" -->
                  <!-- style="height: 30px; line-height: 1.2; padding-top: 5px" -->
                  <v-list-tile-title>
                    <!-- <span class="">FROM:</span> -->

                    <span class="right" v-if="c_user.edit">
                      <v-btn @click="delete_log(l)" small icon class="mt-0">
                        <v-icon small color="red">delete</v-icon></v-btn>
                      <v-btn :key="l.id + 'b'" small class="mr-0 mt-0" icon @click="editInsurance(l)">
                        <v-icon small color="black">edit</v-icon>
                      </v-btn>
                    </span>

                    <!-- <span v-if="l.old_insurance"
                              >{{ get_insurance_name(l.old_insurance) }}
                            </span> -->
                    <span v-else-if="l.insurance_value_note == 'Created at Artwork record creation in CMS'
                        ">
                      Created at Artwork record creation in CMS
                    </span>
                    <!-- <span v-if="!l.old_insurance">
                              {{ get_old_insurance(l) }}
                              <br />
                            </span> -->
                    <!-- <span v-else class="red--text">no insurance entered</span> -->

                    <span class="">Market Value:</span>
                    <b>{{ formatMoney(l.christies_2022_LOWER_MARKET_value) }} {{ l.insurance_value_currency }}</b><br />
                    
                  </v-list-tile-title>

                  <v-list-tile-sub-title class="body-2" v-if="l.reason">
                    <span class="">REASON:</span>
                    {{ l.reason }}
                  </v-list-tile-sub-title>

                  <!-- <v-list-tile-title class="body-2" v-if="l.insurance_history_authoriser">
                            <span class="text--primary">Authoriser:</span>
                            {{ l.insurance_history_authoriser }}
                          </v-list-tile-title> -->

                  <v-list-tile-sub-title class="body-2" v-if="l.insurance_value_note &&
                    l.insurance_value_note != 'Created at Artwork record creation in CMS'
                    ">
                    <span class="">NOTE:</span>
                    {{ l.insurance_value_note }}
                  </v-list-tile-sub-title>

                </v-flex>
                <!-- (Added {{l.insurance_value_date}} by {{l.created_by}}) -->
                <!-- <v-list-tile-action><v-btn @click="delete_log" icon ><v-icon>delete</v-icon></v-btn></v-list-tile-action> -->
              </v-flex>
              <v-divider class="my-2" :key="`a${l.id}`"></v-divider>
            </template>
          </v-flex>
        </v-list>
      </v-flex>
        <table class="mx-3 pa-2 mt-0 pa-0 mb-3 white"
          v-if="showList && artwork.Valuation_Date_all">
          <tr>
            <th style="text-align: left;">Legacy</th>
          </tr>
          <tr v-for="item in old_insurance_table" :key="item.id">
            <td>{{ item.date }} </td><td> {{ item.type }} </td><td> {{ item.method }} </td>
          </tr>
        </table>
      <!-- </v-flex> -->
      <!-- <v-divider class="mt-4 black ml-3 mr-2"></v-divider> -->
    </v-layout>
  </div>
</template>

<script>
import axios from '@/utils/apiClient'
import { serverBus } from '../../main'
import constants from '@/data/constants'

function dynamicSort(property, property2) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    if (a[property] > b[property]) return 1 * sortOrder;
    if (a[property] < b[property]) return -1 * sortOrder;
    
    // Secondary sort using property2
    if (property2 && a[property2] && b[property2]) {
      if (a[property2] > b[property2]) return 1;
      if (a[property2] < b[property2]) return -1;
    }
    
    return 0;
  }
}

export default {
  name: 'MarketValueHistory',
  props: ['artwork'],
  data: () => ({
    saveDialog: false,
    selectedFilter: 'artwork',
    // selectedPackingFilter: 'all',
    // historyFilter: 'artwork',
    changeArtworkInsurance: false,
    // changeAllParts: false,
    editDialog: false,
    menu_time: false,
    time: null,
    editedInsuranceLog: {},
    selectedPackings: [],
    menu2: false,
    menu2a: false,
    showUpload: false,
    showList: false,
    show: false,
    errors: '',
    artwork_insurance_log: {
      created_by: '',
      christies_2022_LOWER_MARKET_value: '',
      insurance_value_currency: '',
      insurance_value_note: '',
      insurance_value_date: '',
      christies_2022_LOWER_MARKET_value: '',
      market_insurance: 'market',
      copy: 'artwork',
      artwork_packing_id: ''
    },
  }),
  computed: {
    old_insurance_table() {
      let a1 = this.artwork.Valuation_Type_all.split(', ');
      let a2 = this.artwork.Valuation_Method_all.split(', ');
      let a3 = this.artwork.Valuation_Date_all.split(', ');

      let result_array = a1.map((item, index) => {
        return {
          id: index,
          type: a1[index],
          method: a2[index],
          date: a3[index]
        }
      });
      return result_array
    },
    old_insurance_from_date_and_copy() {
      // var current = { insurance_value_date: this.artwork_insurance_log.insurance_value_date, copy: this.artwork_insurance_log.copy, artwork_id: this.artwork.id }
      if (
        this.artwork_insurance_log.insurance_value_date &&
        this.artwork_insurance_log.copy
      ) {
        // this.artwork_insurance_log.old_insurance = this.get_old_insurance(current)
        if (this.artwork_insurance_log.copy == 'packings') {
          this.artwork_insurance_log.artwork_id = ''
          return 'Previous Insurance cannot be calculated for packings'
        } else if (
          ['artwork', 'master_physical', 'archive_master'].includes(
            this.artwork_insurance_log.copy
          )
        ) {
          this.artwork_insurance_log.artwork_id = this.artwork.id
          var olderArtworkLogs = this.sorted_artwork_insurance_logs.filter(
            (l) =>
              l.copy == this.artwork_insurance_log.copy &&
              l.insurance_value_date < this.artwork_insurance_log.insurance_value_date
          )
          console.log(olderArtworkLogs)
          if (olderArtworkLogs.length > 1) {
            // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_insurance_log')
            var previous = olderArtworkLogs[0]
            if (previous) {
              this.artwork_insurance_log.old_insurance =
                previous.christies_2022_LOWER_MARKET_value
              return previous.christies_2022_LOWER_MARKET_value
            } else {
              this.artwork_insurance_log.old_insurance = 465
              return 465
            }
          } else {
            this.artwork_insurance_log.old_insurance = 465
            return 465
          }
        }
      } else {
        return 'Copy and Change Date must be selected before calculating old Insurance'
      }
    },
    sorted_artwork_insurance_logs() {
      if (this.artwork && Array.isArray(this.artwork.artwork_insurance_logs)) {
        return this.artwork.artwork_insurance_logs
          // .filter((l) => l.market == '1')
          .sort(dynamicSort('insurance_value_date'))
          .reverse();
      }
      return [];
    },
    filtered_artwork_insurance_logs() {
      var o = this.sorted_artwork_insurance_logs.filter(
        (l) => l.market_insurance == 'market'
      )
      // console.log(o)
      return o
    },
    insurances() {
      return Object.assign([], this.$store.getters.enabled_insurances).sort(
        dynamicSort('name')
      )
    },
    lastInsuranceLogArtwork() {
      return this.getLastLog(this.filtered_artwork_insurance_logs, 'artwork')
    },
    // lastInsuranceLogMasterPhysical() {
    //   return this.getLastLog(
    //     this.filtered_artwork_insurance_logs,
    //     'master_physical'
    //   )
    // },
    // lastInsuranceLogArchiveMaster() {
    //   return this.getLastLog(
    //     this.filtered_artwork_insurance_logs,
    //     'archive_master'
    //   )
    // },
    // lastInsuranceLogAccessCopy() {
    //   return this.getLastLog(this.filtered_artwork_insurance_logs, 'access_copy')
    // },
  },
  watch: {
    // changeAllParts: function () {
    //   this.selectAllParts()
    // },
    artwork_insurance_log: {
      handler(val) {
        console.log('watch')
        if (this.artwork_insurance_log.insurance_value_date) {
          this.artwork_insurance_log.old_insurance ==
            this.old_insurance_from_date_and_copy
        }
      },
      deep: true,
    },
  },
  methods: {
    // lastInsuranceLogArtworkPacking(id) {
    //   return this.getLastLog(this.artwork.artwork_insurance_logs, 'packings', id)
    // },
    switch_change_dialog() {
      this.showUpload = !this.showUpload
      if (this.showUpload) {
        this.artwork_insurance_log.old_insurance =
          this.old_insurance_from_date_and_copy
      }
    },
    // get_old_insurance_from_date_and_copy() {
    //   // var current = { insurance_value_date: this.artwork_insurance_log.insurance_value_date, copy: this.artwork_insurance_log.copy, artwork_id: this.artwork.id }
    //   if(this.artwork_insurance_log.insurance_value_date && this.artwork_insurance_log.copy) {
    //     // this.artwork_insurance_log.old_insurance = this.get_old_insurance(current)
    //     if (this.artwork_insurance_log.copy == 'packings') {
    //         return 'Previous Insurance cannot be calculated for packings'
    //     } else if (['artwork','master_physical','archive_master'].includes(this.artwork_insurance_log.copy)) {
    //       var olderArtworkLogs = this.sorted_artwork_insurance_logs
    //         .filter(l => l.artwork_id = this.artwork_insurance_log.artwork_id
    //           && l.copy == this.artwork_insurance_log.copy
    //           && l.insurance_value_date < this.artwork_insurance_log.insurance_value_date)
    //       if (olderArtworkLogs.length > 1) {
    //         // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_insurance_log')
    //         var previous = olderArtworkLogs[0]
    //         if(previous) {
    //           this.artwork_insurance_log.old_insurance = previous.artwork_insurance_id
    //           return  previous.artwork_insurance_id
    //         } else {
    //           return 'no previous log for this packing'
    //         }
    //       } else {
    //         return 'no previous log for this packing'
    //       }
    //     }
    //   } else {
    //     return 'Copy and Change Date must be selected before calculating old Insurance'
    //   }
    // },
    // get_old_insurance(log) {
    //   if (log.copy == 'packings') {
    //     var packingLogs = this.sorted_artwork_insurance_logs.filter(
    //       (l) => (l.artwork_packing_id = log.artwork_packing_id)
    //     )
    //     if (packingLogs.length > 1) {
    //       var indexOfcurrent = packingLogs.indexOf(log)
    //       var previous = packingLogs[indexOfcurrent + 1]
    //       return previous
    //         ? previous.artwork_insurance_id
    //         : 'no previous log for this packing'
    //     } else {
    //       return 'no previous log for this packing'
    //     }
    //   } else if (
    //     ['artwork', 'master_physical', 'archive_master'].includes(log.copy)
    //   ) {
    //     var artworkLogs = this.sorted_artwork_insurance_logs.filter(
    //       (l) => (l.artwork_id = log.artwork_id && l.copy == log.copy)
    //     )
    //     if (artworkLogs.length > 1) {
    //       var indexOfcurrent = artworkLogs.indexOf(log)
    //       var previous = artworkLogs[indexOfcurrent + 1]
    //       return previous
    //         ? previous.artwork_insurance_id
    //         : 'no previous log for this packing'
    //     } else {
    //       return 'no previous log for this packing'
    //     }
    //   }
    //   // christies_2022_LOWER_MARKET_value
    // },
    // toggleCopyFilter(c) {
    //   console.log(c)
    //   this.selectedFilter = c
    //   if (c == 'packings') {
    //     this.selectedPackingFilter = 'all'
    //   }
    // },
    // togglePackingFilter(c) {
    //   this.selectedPackingFilter = c
    // },
    // selectAllParts() {
    //   if (this.changeAllParts) {
    //     this.artwork.artwork_packings.forEach((p) => {
    //       if (!this.selectedPackings.includes(p)) {
    //         this.selectedPackings.push(p)
    //       }
    //     })
    //   } else {
    //     this.selectedPackings = []
    //   }
    // },
    getLastLog(logs, copy, id) {
      if (logs && logs.length > 0) {
        var out = Object.assign([], logs)
          .sort(function (a, b) {
            // If either value is null/undefined/empty, push it to the end
            if (!a.insurance_value_date) return 1
            if (!b.insurance_value_date) return -1
            
            // Normal date comparison for entries that have dates
            if (a.insurance_value_date > b.insurance_value_date) {
              return -1
            }
            if (a.insurance_value_date < b.insurance_value_date) {
              return 1
            }
            return 0
          })[0]
        
        if (out) {
          return out
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    // getPacking(id) {
    //   return this.artwork.artwork_packings.find((ap) => ap.id === id)
    // },
    editInsurance(l) {
      console.log(l)
      this.editedInsuranceLog = l
      this.editDialog = true
    },
    // insurance_name (id) {
    //   // console.log(id)
    //   if (id > 0) {
    //     var a = this.$store.state.insurances.find(l => l.id === id)
    //     if (a) {
    //       return a.name
    //     } else {
    //       return 'Insurance not found in CMS.'
    //     }
    //   } else {
    //     return 'Insurance not found in CMS.'
    //   }
    // },
    download() { },
    delete_log(item) {
      let r = confirm(
        'Are you sure you want to delete this Market Value History entry?'
      )
      if (r) {
        this.delete_log_action(item)
      }
    },
    delete_log_action(item) {
      serverBus.$emit('showSnackbar', 'Deleting Market Value history.', 'black')
      let url = `${this.$globals.apiserver}/artwork_insurance_logs/${item.id}.json`
      axios
        .delete(url, item)
        .then((response) => {
          this.$store.dispatch('updateArtwork', this.artwork.id)
          serverBus.$emit('showSnackbar', 'Market Value history Deleted.', 'green')
          this.errors = {}
          const index = this.artwork.artwork_insurance_logs.indexOf(item)
          if (index >= 0) this.artwork.artwork_insurance_logs.splice(index, 1)
          // const index = this.artwork.artwork_costs.indexOf(item)
          // this.artwork.artwork_insurance_logs.push(response.data);
          // @artwork.christies_2022_LOWER_MARKET_value = @artwork_insurance_log.id
          // elsif @artwork_insurance_log.copy = 'master_physical'
          // @artwork.master_physical_insurance_id = @artwork_insurance_log.id
          // elsif @artwork_insurance_log.copy = 'archive_master'
          // @artwork.archive_master_insurance_id = @artwork_insurance_log.id
          // elsif @artwork_insurance_log.copy = 'access_copy'
          // @artwork.access_copy_insurance_id = @artwork_insurance_log.id
          // this.active_artwork_insurance_logs = this.artwork.artwork_insurance_logs
          // this.$store.commit('DELETE_LOG', response.data)
          this.active_artwork_insurance_logs =
            this.$store.state.artwork_insurance_logs
          // this.showUpload = !this.showUpload
          return false
        })
        .catch((error) => {
          serverBus.$emit(
            'showSnackbar',
            'There was an Error deleting Cost.',
            'red'
          )
          // console.log(error)
          this.errors = error.response.data
        })
    },
    showSaveDialog() { this.saveDialog = true },
    save_artwork_insurance_log() {
      this.saveDialog = false
      // console.log('save_artwork_insurance_log')
      serverBus.$emit(
        'showSnackbar',
        `Saving Insurance History Entry…`,
        'green'
      )

      // NASETUJEM LOG BASICS
      this.artwork_insurance_log.created_by = this.c_user.id
      this.artwork_insurance_log.artwork_id = this.artwork.id
      this.artwork_insurance_log.market_insurance = 'market'
      // ZMENIM LOGS ARTWORKU NA POLE, AK BOLO NULL, ABY SOM MOHOL OD NEHO PRIDAVAT
      if (!this.artwork.artwork_insurance_logs) {
        this.artwork.artwork_insurance_logs = []
      }

      // IF I AM CHANGING PACKINGS - MUST BE SOME SELECTED
      // if (
      //   this.artwork_insurance_log.copy === 'packings' &&
      //   this.selectedPackings &&
      //   this.selectedPackings.length > 0
      // ) {

      //   // FOR EACH PACKING CREATE LOG AND CHANGE ITS INSURANCE
      //   for (const sp in this.selectedPackings) {
      //     // console.log(this.selectedPackings[sp].id)
      //     this.artwork_insurance_log.artwork_packing_id = this.selectedPackings[sp].id

      //     // ADD LOG FOR THIS PACKING - PACKING ITSELF IS CHANGED ON THE SERVER
      //     // console.log(this.artwork_insurance_log)
      //     axios
      //       .post(`${this.$globals.apiserver}/artwork_insurance_logs.json`, {
      //         artwork_insurance_log: this.artwork_insurance_log,
      //       })
      //       .then((response) => {
      //         this.errors = {}
      //         // this.artwork.artwork_insurance_logs.push(response.data);
      //         // @artwork.christies_2022_LOWER_MARKET_value = @artwork_insurance_log.id
      //         // elsif @artwork_insurance_log.copy = 'master_physical'
      //         // @artwork.master_physical_insurance_id = @artwork_insurance_log.id
      //         // elsif @artwork_insurance_log.copy = 'archive_master'
      //         // @artwork.archive_master_insurance_id = @artwork_insurance_log.id
      //         // elsif @artwork_insurance_log.copy = 'access_copy'
      //         // @artwork.access_copy_insurance_id = @artwork_insurance_log.id
      //         // this.active_artwork_insurance_logs = this.artwork.artwork_insurance_logs
      //         // this.$store.commit('ADD_LOG', response.data)
      //         // this.active_artwork_insurance_logs = this.$store.state.artwork_insurance_logs
      //         this.showUpload = !this.showUpload
      //       })
      //       .catch((error) => {
      //         console.log(error)
      //         // this.errors = error.response.data;
      //       })
      //     this.artwork_insurance_log.artwork_packing_id = null
      //   }

        // IF ALSO ARTWORK INSURANCE IS SELECTED TO BE CHANGED
        // if (this.changeArtworkInsurance) {
          // console.log('changeArtworkInsurance')

          // SAVE NEW ARTWORK INSURANCE - only if insurance_value_date is later than latest log
          // if (this.artwork_insurance_log.insurance_value_date > this.lastInsuranceLogArtwork.insurance_value_date) {
          //   // console.log(this.artwork_insurance_log.insurance_value_date)
          //   // console.log(this.lastInsuranceLogArtwork.insurance_value_date)
          //   axios
          //     .put(
          //       `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`,
          //       {
          //         artwork: {
          //           christies_2022_LOWER_MARKET_value:
          //             this.artwork_insurance_log.christies_2022_LOWER_MARKET_value,
          //         },
          //       }
          //     )
          //     .then((response) => {
          //       console.log('changeArtworkInsurance response change artwork')

          //       this.errors = {}
          //       this.artwork.artwork_insurance_logs.push(response.data)

          //       // ON SAVE SUCCESS SET CURRENT ARTWORK'S INSURANCE TO NEW INSURANCE
          //       // if (this.artwork_insurance_log.copy === 'artwork') {
          //       //   this.artwork.christies_2022_LOWER_MARKET_value = this.artwork_insurance_log.christies_2022_LOWER_MARKET_value
          //       // } else if (this.artwork_insurance_log.copy === 'master_physical') {
          //       //   this.artwork.master_physical_insurance_id = this.artwork_insurance_log.christies_2022_LOWER_MARKET_value
          //       // } else if (this.artwork_insurance_log.copy === 'archive_master') {
          //       //   this.artwork.archive_master_insurance_id = this.artwork_insurance_log.christies_2022_LOWER_MARKET_value
          //       // } else if (this.artwork_insurance_log.copy === 'access_copy') {
          //       //   this.artwork.access_copy_insurance_id = this.artwork_insurance_log.christies_2022_LOWER_MARKET_value
          //       // }
          //       // this.$store.commit('ADD_LOG', response.data)
          //       // this.active_artwork_insurance_logs = this.$store.state.artwork_insurance_logs
          //       this.changeArtworkInsurance = false
          //     })
          // }

          // ADD LOG FOR ARTWORK
          this.artwork_insurance_log.copy = 'artwork'
          axios
            .post(`${this.$globals.apiserver}/artwork_insurance_logs.json`, {
              artwork_insurance_log: this.artwork_insurance_log,
            })
            .then((response) => {
              console.log('changeArtworkInsurance response add log')

              this.errors = {}
              this.artwork.artwork_insurance_logs.push(response.data)
              this.artwork.christies_2022_LOWER_MARKET_value = this.artwork_insurance_log.christies_2022_LOWER_MARKET_value
              this.$store.commit('ADD_INSURANCE_LOG', response.data)
              this.active_artwork_insurance_logs = this.$store.state.artwork_insurance_logs
              // this.showUpload = !this.showUpload
              this.artwork_insurance_log = {
                christies_2022_LOWER_MARKET_value: '',
                insurance_value_currency: '',
                insurance_value_note: '',
                insurance_value_date: '',
                insurance_valuer: '',
                market_insurance: 'market',
                reason: '',
                created_by: this.c_user.id,
              }
            })
            .catch((error) => {
              // console.log(error)
            })
          this.changeAllParts = false
        // }

        // this.$store.dispatch('loadPackings')
        this.$emit('getArtwork')
      // } else {
      //   console.log('single')
      //   // ADD LOG FOR ARTWORK
      //   axios
      //     .post(`${this.$globals.apiserver}/artwork_insurance_logs.json`, {
      //       artwork_insurance_log: this.artwork_insurance_log,
      //     })
      //     .then((response) => {
      //       this.errors = {}
      //       this.artwork.artwork_insurance_logs.push(response.data)
      //       this.artwork.christies_2022_LOWER_MARKET_value =
      //           this.artwork_insurance_log.christies_2022_LOWER_MARKET_value
            
      //       this.$store.commit('ADD_LOG', response.data)
      //       this.active_artwork_insurance_logs =
      //         this.$store.state.artwork_insurance_logs
      //       this.showUpload = !this.showUpload
      //       this.artwork_insurance_log = {
      //         created_by: this.c_user.id,
      //         storage: 'in',
      //         insurance_value_note: '',
      //         insurance_value_date: '',
      //         copy: 'artwork',
      //         valuer: '',
      //         reason: '',
      //         christies_2022_LOWER_MARKET_value: '',
      //         artwork_packing_id: '',
      //       }
      //     })
      //     .catch((error) => {
      //       // console.log(error)
      //     })

        // this.$emit('getArtwork')
      // }
      // this.selectedPackings = []
      this.editDialog = false
      this.saveDialog = false
      this.showUpload = false
      // var aartwork_insurance_log = Object.keys(this.artwork_insurance_log).forEach(k => this.artwork_insurance_log[k]='')
      // console.log(aartwork_insurance_log)
    },
    save_edited_artwork_insurance_log() {
      this.editedInsuranceLog.last_update_by = this.c_user.id
      this.editedInsuranceLog.artwork_id = this.artwork.id
      if (this.editedInsuranceLog.storage === 'in') {
        this.editedInsuranceLog.storage_in = this.editedInsuranceLog.insurance_value_date
      } else {
        this.editedInsuranceLog.storage_out = this.editedInsuranceLog.insurance_value_date
      }
      serverBus.$emit(
        'showSnackbar',
        `Saving Insurance History Entry…`,
        'green'
      )

      if (
        this.editedInsuranceLog.copy === 'packings' &&
        this.selectedPackings &&
        this.selectedPackings.length > 0
      ) {
        for (const sp in this.selectedPackings) {
          this.editedInsuranceLog.artwork_packing_id =
            this.selectedPackings[sp].id
          axios
            .post(`${this.$globals.apiserver}/artwork_insurance_logs.json`, {
              artwork_insurance_log: this.editedInsuranceLog,
            })
            .then((response) => {
              this.errors = {}
              // this.artwork.artwork_insurance_logs.push(response.data);
              // @artwork.christies_2022_LOWER_MARKET_value = @editedInsuranceLog.id
              // elsif @editedInsuranceLog.copy = 'master_physical'
              // @artwork.master_physical_insurance_id = @editedInsuranceLog.id
              // elsif @editedInsuranceLog.copy = 'archive_master'
              // @artwork.archive_master_insurance_id = @editedInsuranceLog.id
              // elsif @editedInsuranceLog.copy = 'access_copy'
              // @artwork.access_copy_insurance_id = @editedInsuranceLog.id
              // this.active_artwork_insurance_logs = this.artwork.artwork_insurance_logs
              this.$store.commit('UPDATE_LOG', response.data)
              this.active_artwork_insurance_logs =
                this.$store.state.artwork_insurance_logs
              this.showUpload = !this.showUpload
            })
            .catch((error) => {
              // console.log(error)
              // this.errors = error.response.data;
            })
        }
        this.artwork_insurance_log = {
          storage: 'in',
          insurance_value_note: '',
          insurance_value_date: '',
          copy: 'artwork',
          insurance_valuer: '',
          reason: '',
          christies_2022_LOWER_MARKET_value: '',
          artwork_packing_id: '',
        }
      } else {
        axios
          .put(
            `${this.$globals.apiserver}/artwork_insurance_logs/${this.editedInsuranceLog.id}.json`,
            {
              artwork_insurance_log: this.editedInsuranceLog,
            }
          )
          .then((response) => {
            this.$emit('getArtwork')
            this.errors = {}
            this.artwork.artwork_insurance_logs = [
              ...this.artwork.artwork_insurance_logs.filter(
                (element) => element.id !== response.data.id
              ),
              response.data,
            ]
              this.artwork.christies_2022_LOWER_MARKET_value =
                this.editedInsuranceLog.christies_2022_LOWER_MARKET_value
            // this.$store.commit("UPDATE_LOG", response.data);
            this.active_artwork_insurance_logs =
              this.$store.state.artwork_insurance_logs
            // this.showUpload = !this.showUpload;
            this.editedInsuranceLog = {
              storage: 'in',
              insurance_value_note: '',
              insurance_value_date: '',
              change_time: '',
              copy: 'artwork',
              insurance_valuer: '',
              reason: '',
              christies_2022_LOWER_MARKET_value: '',
              artwork_packing_id: '',
            }
            this.editDialog = false
          })
          .catch((error) => {
            // console.log(error)
          })
      }
      // var aartwork_insurance_log = Object.keys(this.artwork_insurance_log).forEach(k => this.artwork_insurance_log[k]='')
      // console.log(aartwork_insurance_log)
    },
  },
}
</script>

<style scoped>
/* .activeToggle { background-color: gold; color:hotpink; } */
</style>



// WEBPACK FOOTER //
// src/components/artworks/MarketValueHistory.vue